import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import accountCreatedIcon from "assets/images/accountCreatedIcon.svg";

function ResetPasswordSuccessCard() {
  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justify="center"
      className="form-alignment"
    >
      <Grid item xs={12}>
        <Grid item xs={12}>
          <Card>
            <CardContent className="login-form-content">
              <Typography className="login-card-header">
                <div className="default-card-header-padding">
                  <span className="default-card-header-text">
                    Your password has been reset!
                  </span>
                </div>
              </Typography>
            </CardContent>

            <CardContent className="remove">
              <div className="left-padding">
                <img src={accountCreatedIcon} alt="" />
              </div>
              <div className="default-card-body-padding">
                <p className="default-card-body-text">
                  Your password has been successfully reset. Click below to log
                  in.
                </p>
              </div>
              <div className="whole-padding">
                <Link className="remove" to="/">
                  <span className="default-card-header-text">Go to Log In</span>
                </Link>
              </div>
              {/* </div> */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ResetPasswordSuccessCard;
